import React from 'react';
import './TutorialModal.css';
import { FaLightbulb, FaTimes, FaArrowRight } from 'react-icons/fa';

const TutorialModal = ({ 
  isOpen, 
  onClose, 
  tutorialId, 
  title, 
  message, 
  onDontShowAgain,
  currentStep,
  totalSteps 
}) => {
  if (!isOpen) return null;

  const handleClose = () => {
    // Always mark as completed when closing
    if (onDontShowAgain) {
      onDontShowAgain(tutorialId);
    }
    onClose();
  };

  return (
    <div className="tutorial-modal-overlay" onClick={handleClose}>
      <div className="tutorial-modal" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-header">
          <div className="tutorial-icon">
            <FaLightbulb size={24} />
          </div>
          <h3>{title}</h3>
          <button className="tutorial-close" onClick={handleClose}>
            <FaTimes size={20} />
          </button>
        </div>

        <div className="tutorial-content">
          {message}
        </div>

        <div className="tutorial-footer">
          <div className="tutorial-actions">
            <button className="tutorial-continue" onClick={handleClose}>
              <span>Continuer</span>
              <FaArrowRight size={16} />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorialModal;